import React from 'react'
import { SlSocialGithub } from "react-icons/sl";
import { SlSocialLinkedin } from "react-icons/sl";
import { SlSocialInstagram } from "react-icons/sl";
import { useState, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import './index.css';
export const Home = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [ishovered1, setIshovered1] = useState(false);
  const [ishovered2, setIshovered2] = useState(false);
  const [ishovered3, setIshovered3] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const controls = useAnimation();
  useEffect(() => {
    controls.start({ opacity: 1, x: 0});
  }, [controls]);
  const isDesktop = screenWidth >= 600;
  return (
    <motion.div
      initial={{ opacity: 0, x: -20}}
      animate={controls}
      transition={{ duration: 1 }}
    >
      {isDesktop ? (
        <div className='home-desktop'>
          <div className="details">
            <div className="container">
              <div className="container-two">
                <div className="Header">
                  <div className="Name">
                    Abir
                  </div>
                </div>
                <div className="Header">
                  Bhattacharya
                </div>

                <div className="Icons">
                  <a href="https://github.com/abirbhattacharya82"
                    onMouseEnter={() => setIshovered1(true)}
                    onMouseLeave={() => setIshovered1(false)}
                  >
                    <SlSocialGithub style={{
                      fontSize: '120%',
                      color: ishovered1 ? 'black' : 'white',
                    }} />
                  </a>
                  <a href="https://www.linkedin.com/in/abir-bhattacharya-6982551a9/"
                    onMouseEnter={() => setIshovered2(true)}
                    onMouseLeave={() => setIshovered2(false)}
                  >
                    <SlSocialLinkedin style={{
                      fontSize: '120%',
                      color: ishovered2 ? 'black' : 'white',
                    }} />
                  </a>
                  <a href="https://www.instagram.com/iamabir82/"
                    onMouseEnter={() => setIshovered3(true)}
                    onMouseLeave={() => setIshovered3(false)}
                  >
                    <SlSocialInstagram style={{
                      fontSize: '120%',
                      color: ishovered3 ? 'black' : 'white',
                    }} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="home-small">
          <div className="container">
            <div className="Header">
              <div className="Name">
                Abir
              </div>
              Bhattacharya
            </div>
            <div className="Icons">
              <a href="https://github.com/abirbhattacharya82"
                onMouseEnter={() => setIshovered1(true)}
                onMouseLeave={() => setIshovered1(false)}
              >
                <SlSocialGithub style={{
                  fontSize: '120%',
                  color: ishovered1 ? 'black' : 'white',
                }} />
              </a>
              <a href="https://www.linkedin.com/in/abir-bhattacharya-6982551a9/"
                onMouseEnter={() => setIshovered2(true)}
                onMouseLeave={() => setIshovered2(false)}
              >
                <SlSocialLinkedin style={{
                  fontSize: '120%',
                  color: ishovered2 ? 'black' : 'white',
                }} />
              </a>
              <a href="https://www.instagram.com/iamabir82/"
                onMouseEnter={() => setIshovered3(true)}
                onMouseLeave={() => setIshovered3(false)}
              >
                <SlSocialInstagram style={{
                  fontSize: '120%',
                  color: ishovered3 ? 'black' : 'white',
                }} />
              </a>
            </div>
          </div>
        </div>
      )}
    </motion.div>
  )
}
